import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ObTags = lazyWithPreload(() => import('./ObTags'))
